import type { DropAnimation, Modifiers, UniqueIdentifier } from '@dnd-kit/core';
import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { Portal } from '@headlessui/react';
import { cloneElement, CSSProperties, ReactElement } from 'react';

interface BaseItem {
  id: UniqueIdentifier;
}

interface Props<T extends BaseItem> {
  items: T[];
  renderItem: (item: T) => ReactElement;
  modifiers?: Modifiers;
  dropAnimation?: DropAnimation | null;
}

const SortableActiveItemOverlay = <T extends BaseItem>(props: Props<T>) => {
  const { items, renderItem, modifiers, dropAnimation = null } = props;
  const { active } = useDndContext();
  const activeItem = active ? items.find((i) => i.id === active.id) : null;
  const rect = active?.rect.current.initial;

  if (!activeItem || !rect) {
    return null;
  }

  const child = renderItem(activeItem);

  return (
    <Portal>
      <DragOverlay modifiers={modifiers} dropAnimation={dropAnimation}>
        {cloneElement(child, {
          style: {
            ...((child as any).props.style as CSSProperties),
            width: rect.width,
            height: rect.height,
          },
        } as any)}
      </DragOverlay>
    </Portal>
  );
};

export default SortableActiveItemOverlay;
